/**
 * Thông tin doanh nghiệp dùng chung cho SEO / structured data (JSON-LD).
 * Sửa ở đây là đổi trên mọi trang.
 */
const APP_URL = process.env.APP_URL || 'https://anthu.vn';

const orEnv = (v: string | undefined, fallback: string) =>
  v && v !== '#' ? v : fallback;

const SOCIAL = {
  facebook: orEnv(process.env.FACEBOOK_URL, 'https://www.facebook.com/anthukimcuong'),
  tiktok: orEnv(process.env.TIKTOK_URL, 'https://www.tiktok.com/@anthudiamond'),
  youtube: orEnv(process.env.YOUTUBE_URL, 'https://www.youtube.com/@AnThuKimCuong/'),
  instagram: orEnv(process.env.INSTAGRAM_URL, 'https://www.instagram.com/anthuthediamondstore/'),
};

export const BUSINESS = {
  social: SOCIAL,
  appUrl: APP_URL,
  id: `${APP_URL}/#organization`,
  brand: 'An Thư Kim Cương',
  name: 'An Thư The Diamond Store',
  alternateName: ['An Thư Kim Cương', 'An Thư Diamond', 'Kim cương An Thư'],
  legalName: 'Công ty TNHH An Thư The Diamond Store',
  description:
    'An Thư The Diamond Store là cửa hàng trang sức kim cương tự nhiên tại TP. Hồ Chí Minh, thành lập năm 2017. ' +
    'Chuyên nhẫn, bông tai, dây chuyền, lắc tay kim cương và đá quý; mỗi sản phẩm có chứng thư kiểm định, ' +
    'chính sách bảo hành và thu đổi rõ ràng. Showroom tại 89A Nguyễn Trãi, Phường Bến Thành (Quận 1 cũ, gần chợ Bến Thành), TP. HCM, mở cửa 9:00–21:00 hằng ngày.',
  foundingDate: '2017-07-07',
  taxId: '0314503621',
  logo: `${APP_URL}/logo-bg.png`,
  email: 'anthutechnology@gmail.com',
  phone: '+84333336789', // Hotline mua hàng 033 333 6789
  phoneDisplay: '033 333 6789',
  address: {
    streetAddress: '89A Nguyễn Trãi',
    addressLocality: 'Phường Bến Thành',
    addressRegion: 'Thành phố Hồ Chí Minh',
    postalCode: '700000',
    addressCountry: 'VN',
  },
  // 89A Nguyễn Trãi, Bến Thành, Q.1 — chỉnh lại nếu Google Maps cho toạ độ khác
  geo: { latitude: 10.7686, longitude: 106.6929 },
  hasMap: 'https://maps.app.goo.gl/5FCyoAQoAomH6MNp9',
  openingHours: {
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    opens: '09:00',
    closes: '21:00',
  },
  priceRange: '8.000.000 – 300.000.000 VND',
  mapsUrl: 'https://maps.app.goo.gl/5FCyoAQoAomH6MNp9',
  sameAs: [
    'https://maps.app.goo.gl/5FCyoAQoAomH6MNp9',
    SOCIAL.facebook,
    SOCIAL.tiktok,
    SOCIAL.youtube,
    SOCIAL.instagram,
    orEnv(process.env.APPLE_STORE_URL, 'https://apps.apple.com/vn/app/anthu/id1613308085'),
    orEnv(process.env.GOOGLE_STORE_URL, 'https://play.google.com/store/apps/details?id=com.anthu.diamond'),
  ].filter(Boolean),
};

/** JSON-LD Organization + JewelryStore, xuất trên mọi trang qua MetaTag */
export const organizationJsonLd = () => ({
  '@context': 'https://schema.org',
  '@type': ['Organization', 'JewelryStore'],
  '@id': BUSINESS.id,
  name: BUSINESS.name,
  alternateName: BUSINESS.alternateName,
  legalName: BUSINESS.legalName,
  url: BUSINESS.appUrl,
  logo: { '@type': 'ImageObject', url: BUSINESS.logo },
  image: BUSINESS.logo,
  description: BUSINESS.description,
  foundingDate: BUSINESS.foundingDate,
  taxID: BUSINESS.taxId,
  telephone: BUSINESS.phone,
  email: BUSINESS.email,
  address: { '@type': 'PostalAddress', ...BUSINESS.address },
  geo: { '@type': 'GeoCoordinates', ...BUSINESS.geo },
  hasMap: BUSINESS.hasMap,
  areaServed: [
    { '@type': 'Place', name: 'Phường Bến Thành, Quận 1, TP. Hồ Chí Minh' },
    { '@type': 'City', name: 'Thành phố Hồ Chí Minh' },
    { '@type': 'Country', name: 'Việt Nam' },
  ],
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: BUSINESS.openingHours.days,
      opens: BUSINESS.openingHours.opens,
      closes: BUSINESS.openingHours.closes,
    },
  ],
  priceRange: BUSINESS.priceRange,
  currenciesAccepted: 'VND',
  paymentAccepted: 'Tiền mặt, Chuyển khoản, Thẻ',
  sameAs: BUSINESS.sameAs,
  contactPoint: [
    {
      '@type': 'ContactPoint',
      contactType: 'sales',
      telephone: BUSINESS.phone,
      email: BUSINESS.email,
      availableLanguage: ['vi', 'en'],
    },
  ],
});

/** Ngày hết hạn giá cho Offer: ISO YYYY-MM-DD, luôn ở tương lai */
export const priceValidUntil = (days = 30) =>
  new Date(Date.now() + days * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
